module.exports = __webpack_public_path__ + "static/media/barn-og-forelder.4c92866b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Om/static/barn-og-forelder.png
// module id = 155
// module chunks = 0